import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { copyText } from '@/lib/copyText';

export interface ComposePreviewProps {
  yaml: string;
}

/** Collapsed-by-default read-only view of the stack's compose template. */
export function ComposePreview({ yaml }: ComposePreviewProps) {
  return (
    <details className="rounded-md border bg-card p-3 text-card-foreground">
      <summary className="cursor-pointer rounded-sm text-sm font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring">
        Stack template
      </summary>
      <div className="mt-3 space-y-2">
        <p className="text-xs text-muted-foreground">
          Stack template — the Bridge adds routing labels and security overlays at deploy time.
        </p>
        {yaml.trim() === '' ? (
          <p className="text-sm text-muted-foreground">No template available</p>
        ) : (
          <>
            <div className="flex justify-end">
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => void copyText(yaml)}
                aria-label="Copy stack template"
                className="outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <Copy className="size-4" aria-hidden />
                Copy
              </Button>
            </div>
            <pre
              className="max-h-[50vh] overflow-auto rounded-md border bg-muted/40 p-3 font-mono text-xs outline-none focus-visible:ring-2 focus-visible:ring-ring"
              tabIndex={0}
              role="region"
              aria-label="Stack template"
            >
              {yaml}
            </pre>
          </>
        )}
      </div>
    </details>
  );
}
